import * as screenActions from 'store/actions/screenDimensionsActions.js'
import * as baseActions from 'store/actions/baseactions.js'
import * as folderViewActions from 'store/actions/folderviewactions.js'
import * as commentActions  from 'store/actions/commentactions.js'

export default {
    ...screenActions.default,
    ...baseActions.default,
    ...folderViewActions.default,
    ...commentActions.default
  };

    



    




